import { forwardRef, TextareaHTMLAttributes, useImperativeHandle, useRef } from "react";
import InputTextElement from "./../InputTextElement";

export type TextareaHandle = {
  focus: () => void;
};

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  rtl?: boolean;
  formSubmitted?: boolean;
};

const Textarea = forwardRef<TextareaHandle, TextareaProps>((props, ref) => {
  const elementRef = useRef<InputTextElement>(null);

  useImperativeHandle(ref, () => ({
    focus: () => elementRef.current?.focus(),
  }));

  return <InputTextElement tagName="textarea" {...props} ref={elementRef} />;
});

Textarea.displayName = "Textarea";

export default Textarea;
